/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenu from '../../components/shared/ActionsMenu'
import { useFsiActionMenu } from '../../hooks/useFsiActionMenu'

interface DocumentTableMenuProps {
  item: any
  options?: any
}

export const DocumentTableMenu: React.FC<DocumentTableMenuProps> = ({ item, options = {} }) => {
  const { items, setIsOpen } = useFsiActionMenu(item, options)

  // Add fallback if no items
  if (items.length === 0) {
    items.push({ value: 'ACTION_MENU_NO_ACTION_AVAILABLE', disabled: true })
  }

  return (
    <ActionsMenu
      menuId={`action-menu-browser-${item.id}`}
      onToggle={(open: boolean) => {
        setIsOpen(open)
      }}
      items={items}
    />
  )
}
